import React, { useRef, useState } from 'react'
import classes from './SelectDate.module.scss'
import PropTypes from 'prop-types'
import spoofedEvent from '../../utils/spoofedEvent'
import useClickOutside from '../../customHooks/useClickOutside'
import useKeyDown from '../../customHooks/useKeyDown'
import DatePicker from '../DatePicker/DatePicker'
import { format } from 'date-fns'

const SelectDate = (props) => {
  const {
    title,
    value,
    onChange,
    showTitle = true,
    maxDate = new Date(),
    minDate = new Date(0)
  } = props

  const rootRef = useRef(null)
  const [expanded, setExpanded] = useState(false)

  useKeyDown('Escape', () => setExpanded(false))
  useClickOutside(rootRef, () => setExpanded(false))

  const setDate = (date) => {
    const target = {
      value: date
    }
    const event = spoofedEvent(target)
    onChange(event)
    setExpanded(false)
  }

  const rootClassNames = [classes.root]
  if (expanded) {
    rootClassNames.push(classes.expanded)
  }

  return (
    <div className={rootClassNames.join(' ')} ref={rootRef}>
      <div className={classes.value} onClick={() => setExpanded(!expanded)}>
        <span>
          {
            showTitle && (
              <span>{title} -</span>
            )
          }
          {format(new Date(value), 'dd/MM/yyyy')}
        </span>
      </div>
      {
        Boolean(expanded) && (
          <div className={classes.popup}>
            <DatePicker
              value={value}
              onChange={({ target }) => setDate(target.value)}
              required
              maxDate={maxDate}
              minDate={minDate}
            />
          </div>
        )
      }
    </div>
  )
}

SelectDate.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  showTitle: PropTypes.bool
}

export default SelectDate
